import Dayjs from "dayjs";
import jalaliPlugin from "@zoomit/dayjs-jalali-plugin";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

Dayjs.extend(relativeTime);
Dayjs.extend(isSameOrBefore);
Dayjs.extend(jalaliPlugin, { calendar: "jalali" }).calendar('jalali');

export const dayjs = Dayjs;

export default Dayjs;
